/**
 * Cửa vào màn khách xem ảnh in: đọc token từ đường dẫn.
 *
 * Token KHÔNG bị lau khỏi thanh địa chỉ — link mở trên máy của chính khách, và
 * khách cần giữ lại để mở lại lần sau. (Khác màn iPad ở quầy, nơi vé phải xoá
 * đi vì máy dùng chung.)
 *
 * `PublicPageScroll` là bắt buộc, không phải trang trí: `globals.css` khoá
 * `html, body { overflow: hidden }` cho khung ứng dụng nội bộ, nên trang khách
 * không bọc là bị cắt và cuộn không tới cuối.
 */
import { useParams } from "@tanstack/react-router";

import { PublicPageScroll } from "@/components/PublicPageScroll";
import { CustomerPrintAlbumPage } from "./CustomerPrintAlbumPage";

export function PrintShareRoute() {
  const { token } = useParams({ from: "/anh-in/$token" });
  return (
    <PublicPageScroll>
      <CustomerPrintAlbumPage token={token} />
    </PublicPageScroll>
  );
}
